export default "__VITE_PUBLIC_ASSET__91a8f1a6__"